// extracted by mini-css-extract-plugin
export default {"grid-block":"kEaVl","container":"CcJX3"};